import { Injectable } from '@angular/core';
import { RequestAuthentication } from '../models/request-authentication.model';
import { CookieService } from 'ngx-cookie';

@Injectable()
export class AuthenticationService {
    private key = 'requestAuthentication';

    public instagramCode: string;
    public youtubeCode: string;

    constructor(private cookieService: CookieService) {}

    public getAuthenticationData(): RequestAuthentication {
        const authDataJSON = this.cookieService.get(this.key);
        const authData = JSON.parse(authDataJSON);
        return authData;
    }

    public saveAuthenticationData(authData: RequestAuthentication): void {
        this.cookieService.put(this.key, JSON.stringify(authData));
    }
}
